// @file dropDownMenu.js

const $dropdown = $('.cc-dropdown');
const $dropdownBtn = $('.cc-dropdown__button', $dropdown);
const $dropdownMenu = $('.cc-dropdown__menu', $dropdown);

$dropdownBtn.click(function(e) {
    $(this).next().toggle();
    e.preventDefault();
    e.stopPropagation();
});

/*
 * Close menu with clicking outside
 */
$(document).click(function(e) {
  $dropdownMenu.hide();
});
